import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { VehicleInfoCompatibility, VehicleInfoRequest } from '../vehicleInfo';
import CompatibilityInformation from './CompatibilityInformation.vue';
import {
  compatibilityStatusColumns,
  compatibilityTableColumns
} from './tableColumns';
import './styles/compatibility-table.scss';
import './styles/vehicle-info-compatibility-table.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'VehicleInfoCompatibilityTable',
  props: {
    compatibilities: null,
    updatingRows: null
  },
  emits: ["resubmitVehicleInfo"],
  setup(__props: any, { emit }: { emit: ({(event: 'resubmitVehicleInfo', payload: {
    rowIndex: number;
    request: VehicleInfoRequest;
  }): void;
}), expose: any, slots: any, attrs: any }) {





const columns = compatibilityTableColumns.vehicleInfo;
const statusColumns = compatibilityStatusColumns;
const gridStyle = computed(() => ({
  gridTemplateColumns: `repeat(${columns.length}, minmax(120px, 1fr))`
}));
const tableStyle = computed(() => ({ minWidth: `${columns.length * 150}px` }));

return { __sfc: true,emit, columns, statusColumns, gridStyle, tableStyle, CompatibilityInformation }
}

})